import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { User } from 'lucide-react';

interface UserDisplayProps {
    name?: string | null;
    avatar?: string | null;
    size?: 'sm' | 'md' | 'lg' | 'xs';
    className?: string;
    textColor?: string;
    showName?: boolean;
}

const UserDisplay: React.FC<UserDisplayProps> = ({
    name,
    avatar,
    size = 'sm',
    className,
    textColor = 'text-indigo-700',
    showName = true,
}) => {
    if (!name && !avatar) return <span>—</span>;

    const sizeClasses = {
        xs: { avatar: 'h-4 w-4 text-[8px]', text: 'text-[11px]' },
        sm: { avatar: 'h-5 w-5 text-[10px]', text: 'text-xs' },
        md: { avatar: 'h-8 w-8 text-xs', text: 'text-sm' },
        lg: { avatar: 'h-10 w-10 text-sm', text: 'text-base' },
    };

    return (
        <div className={cn("inline-flex items-center gap-1.5 min-w-0 max-w-full", className)}>
            <Avatar className={cn(sizeClasses[size].avatar, "border border-slate-200 shrink-0")}>
                {avatar && <AvatarImage src={avatar} alt={name || 'Avatar'} />}
                <AvatarFallback className="bg-slate-100 text-slate-400 flex items-center justify-center">
                    <User className="h-4/5 w-4/5 stroke-[2]" />
                </AvatarFallback>
            </Avatar>
            {/* tên dài xuống dòng, không tràn màn điện thoại */}
            {showName && name && (
                <span className={cn("min-w-0 break-words whitespace-normal font-medium", sizeClasses[size].text, textColor)}>
                    {name}
                </span>
            )}
        </div>
    );
};

export default UserDisplay;
